module.exports = __webpack_public_path__ + "img/stock0.94441cfc.png";